import { Icon } from '@/components/ui';

/**
 * How to reach a candidate, on one line: email and phone as links that open
 * the mail app or dialer. Renders nothing when the row carries no contact.
 */
export function CandidateContactLine({ contact }) {
  if (!contact?.email && !contact?.phone) return null;
  const link =
    'text-ink-muted hover:text-brand-700 inline-flex min-w-0 items-center gap-1.5 text-[13px] transition hover:underline';

  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1">
      {contact.email && (
        <a href={`mailto:${contact.email}`} className={link} title="Send an email">
          <Icon name="mail" size={13} className="shrink-0" />
          <span className="truncate">{contact.email}</span>
        </a>
      )}
      {contact.phone && (
        <a href={`tel:${contact.phone}`} className={link} title="Call">
          <Icon name="phone" size={13} className="shrink-0" />
          {contact.phone}
        </a>
      )}
    </div>
  );
}
